import moment from "moment";
import { getOnlyDate } from "./formatDateTime";

export default function testDateSeries(data: any) {
  if (!data) return;
  let isSeries = true;
  if (data.length > 1) {
    for (let i = 0; i < data.length - 1; i++) {
      const date1: any = new Date(moment(data[i].date).format("DD-MM-YYYY"));
      const date2: any = new Date(
        moment(data[i + 1].date).format("DD-MM-YYYY")
      );
      if (date2 - date1 != 86400000) {
        isSeries = false;
        break;
      }
    }

    if (isSeries) {
      if (isTimeSlotSame(data)) return true;
    }
  }
  return false;
}

function isTimeSlotSame(data: any) {
  let isTimeSlotSame = true;
  for (let i = 0; i < data.length - 1; i++) {
    if (
      data[i].startTime != data[i + 1].startTime ||
      data[i].endTime != data[i + 1].endTime
    ) {
      isTimeSlotSame = false;
      break;
    }
  }
  if (isTimeSlotSame) {
    return true;
  }

  return false;
}
